export default __webpack_public_path__ + "static/media/aldi.f6985b47.jpg";